/* eslint-disable prettier/prettier */
export default [
  '<div class="spinner">',
    '<div class="spinner-dot spinner-dot--first"></div>',
    '<div class="spinner-dot spinner-dot--second"></div>',
    '<div class="spinner-dot spinner-dot--third"></div>',
    '<div class="spinner-dot spinner-dot--fourth"></div>',
  '</div>'
].join('');
